/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { Input2, DropDown2 } from "components";
import { useInput } from "hooks";
import { ALL_COUPON_TYPES_PREDICTIVE_TEXT } from "config";

export const OfferPurchaseQtyTextBuilder = ({
  className,
  value,
  onChange = () => {},
}) => {
  const start = useInput("");
  const end = useInput("");
  const suffix = useInput("");
  const withCoupon = useInput("");

  const typeData = [
    { id: "", title: "" },
    { id: "or more", title: "or more" },
    { id: "or less", title: "or less" },
  ];

  const handleUpdateValue = (s, e, suf, withCpn) => {
    switch (suf) {
      case "or more":
        onChange(`w/purchase/${s} ${suf}${withCpn ? " w/" + withCpn : ""}`);
        end.setValue("");
        break;
      case "or less":
        onChange(`w/purchase/${s} ${suf}${withCpn ? " w/" + withCpn : ""}`);
        end.setValue("");
        break;
      case "":
        if (s && e) {
          onChange(`w/purchase/${s}-${e}${withCpn ? " w/" + withCpn : ""}`);
          suffix.setValue("");
        } else if (s) {
          onChange(`w/purchase/${s}${withCpn ? " w/" + withCpn : ""}`);
          end.setValue("");
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (
      value &&
      value.startsWith("w/purchase/") &&
      value.slice(11).length > 0
    ) {
      const main = value.slice(11);
      let quantityStr = main;
      let couponPart = "";

      if (main.includes(" w/")) {
        const parts = main.split(" w/");
        quantityStr = parts[0];
        couponPart = parts[1];
        withCoupon.setValue(couponPart);
      } else {
        withCoupon.setValue("");
      }

      if (quantityStr.includes("or more")) {
        suffix.setValue("or more");
        const qty = quantityStr.slice(0, quantityStr.length - 8).trim();
        start.setValue(qty);
        end.setValue("");
      } else if (quantityStr.includes("or less")) {
        suffix.setValue("or less");
        const qty = quantityStr.slice(0, quantityStr.length - 8).trim();
        start.setValue(qty);
        end.setValue("");
      } else {
        suffix.setValue("");
        if (quantityStr.includes("-")) {
          const parts = quantityStr.split("-");
          start.setValue(parts[0].trim());
          end.setValue(parts[1].trim());
        } else {
          start.setValue(quantityStr.trim());
          end.setValue("");
        }
      }
    }
    return () => {};
  }, [value]);

  return (
    <div className={`${className} mt-1 p-2`}>
      <Title>Offer Text Builder</Title>
      <Container className="mt-2">
        <div className="mt-auto mb-1" style={{ fontSize: 10 }}>
          w/purchase/
        </div>
        <div style={{ width: "100%", marginRight: 10, marginLeft: 10 }}>
          <Input2
            label="Quantity Start"
            value={start.value}
            type="int"
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(e, end.value, suffix.value, withCoupon.value);
            }}
          />
        </div>
        <div style={{ width: "100%", marginRight: 10 }}>
          <Input2
            label="Quantity End"
            value={end.value}
            type="int"
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(start.value, e, suffix.value, withCoupon.value);
            }}
          />
        </div>
        </Container>
        <Container>
          <div className="ml-auto" style={{ width: "30" }}>
            <DropDown2
              label="Suffix"
              data={typeData}
              width={80}
              value={suffix.value}
              onChange={(e) => {
                suffix.setValue(e);
                handleUpdateValue(start.value, end.value, e, withCoupon.value);
              }}
            />
          </div>
          <div className="ml-auto" style={{ width: "50%" }}>
            <DropDown2
              label="w/Coupon"
              data={ALL_COUPON_TYPES_PREDICTIVE_TEXT}
              width={80}
              value={withCoupon.value}
              onChange={(e) => {
                withCoupon.setValue(e);
                handleUpdateValue(start.value, end.value, suffix.value, e);
              }}
            />
          </div>
        </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
